import { diContainer } from '../libs/container';

export class GlobalApi {
    public reload() {
        window.location.reload();
    }

    public pathName() {
        return window.location.pathname;
    }

    public redirectPathNameAndSearch() {
        return window.location.pathname + window.location.search;
    }

    public href(href: string) {
        window.location.href = href;
    }

    public origin() {
        return window.location.origin;
    }

    public innerHeight() {
        return window.innerHeight;
    }

    public innerWidth() {
        return window.innerWidth;
    }

    public addEventListener(type: string, callback: () => void) {
        window.addEventListener(type, callback);
    }

    public removeEventListener(type: string, callback: () => void) {
        window.removeEventListener(type, callback);
    }
}

diContainer.bindAsConstant(GlobalApi, new GlobalApi());
